import { render, staticRenderFns } from "./add-to-smart-wallet-button.vue?vue&type=template&id=9e62988c&scoped=true"
import script from "./add-to-smart-wallet-button.vue?vue&type=script&lang=ts"
export * from "./add-to-smart-wallet-button.vue?vue&type=script&lang=ts"
import style0 from "./add-to-smart-wallet-button.vue?vue&type=style&index=0&id=9e62988c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e62988c",
  null
  
)

export default component.exports